<template>
  <label class="toggle">
    <input ref="checkboxRef" type="checkbox" :name="name" class="is-sr-only" :checked="inputValue" @keydown.enter.prevent="tryAccept" @click.prevent="tryAccept">
    <span class="toggle__slider round" />
  </label>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'accept-switcher',
  props: {
    name: {
      type: String,
      default: 'toggle'
    },
    needs: {
      type: Array,
      default: () => []
    },
    dependants: {
      type: Array,
      default: () => []
    },
    profile: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      default: 'sensitivedata'
    },
    isSensitiveDataSwitcher: {
      type: Boolean,
      default: false
    },
    isNewsletterSwitcher: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    haveProfileData(val) {
      if(val) {
        const urlParams = new URLSearchParams(window.location.search);
        const hasSensitiveDataParam = urlParams.get('sensitiveData') === 'true';
        const hasNewsletterParam = urlParams.get('marketingOptIn') === 'true';
        const communicationTabSelected = window.location.href.split('#')[1] === "communications"
        if(this.isSensitiveDataSwitcher && !this.inputValue && hasSensitiveDataParam) {
          this.$refs.checkboxRef.click()
        }
        if(this.isNewsletterSwitcher && communicationTabSelected && !this.inputValue && hasNewsletterParam) {
          this.$refs.checkboxRef.click()
        }
      }
    }
  },
  computed: {
    ...mapState('auth', ['isUpdateProfilePending']),
    ...mapGetters('auth', ['haveProfileData']),
    inputValue() {
      return this.profile[this.field]
    },
    haveNeededAcceptence() {
      return this.needs.length === 0 || this.needs.map(k => !!this.profile[k]).filter(k => !k).length === 0
    },
    haveDependentAcceptence() {
      return this.dependants.length > 0 && this.dependants.map(k => !!this.profile[k]).filter(k => k).length > 0
    }
  },
  methods: {
    ...mapActions('auth', ['updateProfile']),
    tryAccept(e) {
      if (this.isUpdateProfilePending) {
        return
      }
      const request = {
        [this.field]: !this.inputValue
      }
      if (!this.inputValue && !this.haveNeededAcceptence) {
        this.$emit('open', e)
      } else if (this.inputValue && this.haveDependentAcceptence) {
        this.dependants.forEach(d => (request[d] = false))
        this.updateProfile({ data: request, endpoint: this.endpoint })
      } else {
        this.updateProfile({ data: request, endpoint: this.endpoint })
      }
    }
  }
}
</script>
